import { render, staticRenderFns } from "./LogisticsPic.vue?vue&type=template&id=28b2a520&scoped=true&"
import script from "./LogisticsPic.vue?vue&type=script&lang=js&"
export * from "./LogisticsPic.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsPic.vue?vue&type=style&index=0&id=28b2a520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2a520",
  null
  
)

export default component.exports